export default __webpack_public_path__ + "static/media/georgemathew.bd3cf13c.jpg";